module.exports = __webpack_public_path__ + "static/hypnotic_pattern_mtg_ahbg-1ebe466ebf9b2be5153f76d2e3568c65.webp";